import React from 'react';
import { HeaderSubWrap } from './style';
import theme from '../../styles/theme';
import FeatherIcon from 'feather-icons-react';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATH from '../../routes/config';
import { useApp } from '../../contexts/AppContext';

const HeaderSub = ({
  backIcon = true,
  homeIcon = true,
  menuIcon = true,
  closeIcon = false,
  pageTitle = '',
  showBanner = false,
  onClickBackBtn,
}) => {
  const navigate = useNavigate();
  const {
    auth: { authenticated },
  } = useApp();

  return (
    <HeaderSubWrap showBanner={showBanner}>
      <div>
        {backIcon && (
          <button type="button">
            <FeatherIcon
              icon="chevron-left"
              size={24}
              color={theme.color.grey3}
              onClick={onClickBackBtn ? onClickBackBtn : () => navigate(-1)}
            />
          </button>
        )}
        {homeIcon && (
          <button type="button">
            <FeatherIcon
              icon="home"
              size={22}
              color={theme.color.grey3}
              onClick={() => {
                navigate('/');
              }}
            />
          </button>
        )}
      </div>
      <h2>{pageTitle}</h2>
      <div>
        {menuIcon && (
          <>
            {authenticated ? (
              <button type="button">
                <FeatherIcon
                  icon="menu"
                  size={22}
                  color={theme.color.grey3}
                  onClick={() => {
                    navigate(ROUTE_PATH.mypage.main);
                  }}
                />
              </button>
            ) : (
              <button type="button">
                <FeatherIcon
                  icon="user"
                  size={22}
                  color={theme.color.grey3}
                  onClick={() => {
                    navigate(ROUTE_PATH.mypage.main);
                  }}
                />
              </button>
            )}
          </>
        )}

        {closeIcon && (
          <button type="button">
            <FeatherIcon
              icon="x"
              size={22}
              onClick={() => {
                try {
                  if (window.opener) {
                    window.close(); // 스크립트로 열린 창이면 닫음
                  } else {
                    navigate('/');
                  }
                } catch (error) {
                  navigate('/');
                }
              }}
              tabIndex={0}
            />
          </button>
        )}
      </div>
    </HeaderSubWrap>
  );
};

export default HeaderSub;
